import React,{useState} from 'react';
import RenderButton from '../common/button';



const Headder = ({onChange}) => {

    const [bar, setbar] = useState('btn btn-primary');
    const [line, setline] = useState('btn btn-outline-dark');
    const [area, setarea] = useState('btn btn-outline-dark');
    const [donut, setdonut] = useState('btn btn-outline-dark');
  
 

    const handleonClick = ({ currentTarget: input }) => {
        if (input.value=='bar') {
            disabledlabel();
            setbar('btn btn-primary'); 
        }else if (input.value=='line'){
            disabledlabel();
            setline('btn btn-primary'); 
        }else if (input.value=='area'){
            disabledlabel();
            setarea('btn btn-primary'); 
        }else if (input.value=='pie'){
            disabledlabel();
            setdonut('btn btn-primary'); 
        }
        onChange(input.value);
    }
  


const disabledlabel = () => {
    setbar('btn btn-outline-dark')
    setline('btn btn-outline-dark') ;
    setarea('btn btn-outline-dark') ;
    setdonut('btn btn-outline-dark') ;
}



    return ( 
<div className='container'>
            <div className="row">
        

              <div className="row justify-content-end align-items-center">
                  <div className="col-auto mb-3 px-0"><ul className="btn-group p-0 m-0 ">
                     <RenderButton 
                     label ="bar chart"
                     width ={100}
                     value="bar"
                     onClick ={handleonClick}
                     className = {bar}
                      />
                    <RenderButton 
                     value="line"
                     label ="line chart"
                     onClick ={handleonClick}
                     className = {line}
                      />
                        <RenderButton 
                     value="area"
                     label ="area chart"
                     onClick ={handleonClick}
                     className = {area}
                      />
                         
                         {/* <RenderButton 
                     value="pie"
                     label ="donut chart"
                     onClick ={handleonClick}
                     className = {donut}
                      />   */}
                      </ul>
                      </div>
                      </div>


            </div>
          </div>

     );
}
 
export default Headder;

